module.exports = __webpack_public_path__ + "img/d156f7c.jpg";